import { useTranslation } from 'react-i18next';

import V_SRC from './v_homepage.png';
import INHOUSE_SRC from './inhouse_homepage.png';
import { IImageMeta } from '~/assets';

export const useQRCode = (): IImageMeta => {
  const { t } = useTranslation();
  const src = __BUILD_TYPE__ === 'online' ? V_SRC : INHOUSE_SRC;
  const alt = `${t('officialWebsite_download_title')} - ${t('officialWebsite_download_desc')}`;

  return {
    src,
    alt,
  };
};
